// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1zV6V","cardHeader":"styles_cardHeader__kV5by","buttons":"styles_buttons__3jiX2"};